import { render, staticRenderFns } from "./PostionAndTime.vue?vue&type=template&id=ca24c20c&scoped=true"
import script from "./PostionAndTime.vue?vue&type=script&lang=js"
export * from "./PostionAndTime.vue?vue&type=script&lang=js"
import style0 from "./PostionAndTime.vue?vue&type=style&index=0&id=ca24c20c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca24c20c",
  null
  
)

export default component.exports